import { render, staticRenderFns } from "./AddNoteCustomer.vue?vue&type=template&id=4b135f39&scoped=true"
import script from "./AddNoteCustomer.vue?vue&type=script&lang=js"
export * from "./AddNoteCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b135f39",
  null
  
)

export default component.exports